import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {cancelCancelMetaOrder} from "../../actions/SalesApiActions";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmWithReasonForm";
import {Map, fromJS} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, _props) {
  let errors = Map();
  errors = validatePresence(errors, values, "reason");
  return errors.toJS();
}

// From Facebook API
// https://developers.facebook.com/docs/commerce-platform/order-management/cancellation-refund-api#reason_code
const META_CANCELLATION_REASONS = fromJS([
  { id: "CUSTOMER_REQUESTED", title: "Cancellation requested by the buyer." },
  { id: "OUT_OF_STOCK", title: "Product is out of stock at fulfillment." },
  { id: "INVALID_ADDRESS", title: "Unable to ship to address provided by the buyer." },
  { id: "SUSPICIOUS_ORDER", title: "Order is suspicious/possible fraud." },
]);

class MetaOrderCancellationFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("metaOrderId", this.props.metaOrderId)
    return this.props.cancelMetaOrder(updatedValues.toJS())
      .then((response) => {
        if (response.data.cancelMetaOrder.errors.length <= 0) {
          this.props.cancelCancelMetaOrder();
        } else {
          let errors = createValidationErrors(response.data.cancelMetaOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCancelMetaOrder();
  }

  render() {
    return (
      <Form
        options={META_CANCELLATION_REASONS}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}>
        <p>Cancellation cannot work on completed orders.</p>
      </Form>
    )
  }
}


const CANCEL_META_ORDER = gql`
  mutation cancelMetaOrder($data: CancelMetaOrderInput!) {
    cancelMetaOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CANCEL_META_ORDER, {
    props: ({ mutate }) => ({
      cancelMetaOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelCancelMetaOrder})(withMutation(MetaOrderCancellationFormContainer));
